module.exports = __webpack_public_path__ + "static/media/GH-White16.07bf33f7.png";